export const PatientCardData = {
    firstName: 'Іван',
    lastName: 'Петренко',
    patronymic: 'Олексійович',
    age: 45,
    gender: 'Чоловік',
    id: '123456789',
    qrCodeId: 'QR123456789',
    additionalInfo: 'Хронічні захворювання: діабет, астма. Лікарські рекомендації: контроль рівня цукру в крові.',
    conclusions: [
        {
            id: 'ZL-001',
            visitDate: '2023-09-10',
            formationDate: '2023-09-12',
            doctor: 'Лікар Іванов',
            status: 'Готово',
            department: 'Кардіологія',
            pdfLink: '/pdf/ZL-001',
        },
        {
            id: 'ZL-002',
            visitDate: '2023-08-15',
            formationDate: '2023-08-16',
            doctor: 'Лікар Петров',
            status: 'В обробці',
            department: 'Неврологія',
            pdfLink: '/pdf/ZL-002',
        },
        {
            id: 'ZL-003',
            visitDate: '2023-07-20',
            formationDate: '2023-07-22',
            doctor: 'Лікар Сидоренко',
            status: 'Готово',
            department: 'Онкологія',
            pdfLink: '/pdf/ZL-003',
        },
    ]
};